import { render, staticRenderFns } from "./HoldCarts.vue?vue&type=template&id=4da5745b&scoped=true"
import script from "./HoldCarts.vue?vue&type=script&lang=js"
export * from "./HoldCarts.vue?vue&type=script&lang=js"
import style0 from "./HoldCarts.css?vue&type=style&index=0&id=4da5745b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da5745b",
  null
  
)

export default component.exports